<template>
  <div id="chart_div"></div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      stats: [
        [ 'Date', 'Subscription Created', 'Total' ]
      ],
    }
  },

  mounted() {
    this.getChart()
  },

  methods: {
    async getChart() {
      try {
        var { data } = await this.$http.get(`/statistics`)
      } catch(err) {
        this.$message.error(err.response.data.message)
      }

      data.forEach(item => {
        this.stats.push([ new Date(item.date), item.subscribers_created, item.subscribers_total ])
      })

      google.charts.load('current', { packages: [ 'corechart' ] })
      google.charts.setOnLoadCallback(this.drawBackgroundColor)
    },

    drawBackgroundColor() {
      var data = new google.visualization.arrayToDataTable(this.stats)
      var chart = new google.visualization.ComboChart(document.getElementById('chart_div'))

      chart.draw(data, {
        legend: { position: 'none' },
        chartArea: { width: '80%', height: '80%' },
        height: 400,
        seriesType: 'line',
        series: {
          0: { color: '#95a3b3', type: 'bars', targetAxisIndex: 1 },
          1: { color: '#FF7E30', type: 'line', targetAxisIndex: 0 },
        },
        hAxis: { gridlines: { color: '#f1f3f3' } },
        vAxes: {
          0: { title: 'Total subscribers', gridlines: { color: '#f1f3f3' } },
          1: { title: 'Subscribers created per day', gridlines: { color: 'none' } },
        },
      })
    },
  },
}
</script>
